export const PRODUCT_URLS = {
  adamApp: 'https://adamhealthai.com',
  ipos: 'https://ipos-web.onrender.com',
} as const;

export const CONTACT = {
  email: 'sales@zendi.org',
  phone: '+263 77 719 8146',
  city: 'Harare, Zimbabwe',
} as const;
